import axios from './axios';
import { SERVICE_URL } from '@/config';

const BASE_URL = `${SERVICE_URL}/locales`;
const PROJECT_ID = 1;
export function getTranslations(language: string, namespace: string) {
  return axios.get(`${BASE_URL}/${PROJECT_ID}/${namespace}/${language}`);
}
